export default function CTA() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative py-32 lg:py-40 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ed5b88279580221173fe3c953366e520.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/70 to-gray-900/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-serif text-5xl lg:text-7xl font-bold text-white mb-6 uppercase tracking-wide">
          당신의 브랜드를 현실로
        </h2>
        
        <p className="text-xl lg:text-2xl text-gray-200 mb-4 font-light">
          글로리브와 함께 시작하세요
        </p>
        
        <p className="text-base text-gray-300 mb-12 max-w-2xl mx-auto">
          전문 상담부터 제품 출시까지 완벽하게 지원합니다
        </p>

        <button
          onClick={() => scrollToSection('contact')}
          className="group inline-flex items-center gap-4 px-10 py-5 bg-gray-900 text-white text-base font-medium rounded-full hover:bg-gray-800 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-700/20 hover:scale-105 whitespace-nowrap"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-full">
            <i className="ri-phone-line text-xl"></i>
          </div>
          <span>무료 상담 신청하기</span>
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
        </button>

        <p className="text-sm text-gray-400 mt-6">
          평균 24시간 내 답변 드립니다
        </p>
      </div>
    </section>
  );
}
